import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { addFeedBackService } from "../../core/services/transactions.service";
import AppButton from "../shared/AppBtn";

const Feedback = () => {
    const [val, setVal] = useState("");
    const [id, setId] = useState("");
    const [loading, setLoading] = useState(false);
    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        if (!val || !id) {
            toast.error("Missing fields");
            return;
        }
        const res = await addFeedBackService({
            id,
            feedback: val,
        });

        if (res) {
            toast.success("Feedback successfully submitted");
            setVal('')
            setTimeout(() => {
                window.open("about:blank", "_self");
                window.close();
            }, 2);

        }else{
            toast.error('Feedback already submitted for this transaction')
        }

        setLoading(false);
    };

    useEffect(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const { transactionId } = Object.fromEntries(urlSearchParams.entries());
        const decodedTransactionId = transactionId.replace(/ /g, '+');
        setId(decodedTransactionId);
    }, []);

    return (
        <Container className="p-5 h-75 d-flex justify-content-center align-items-center">
            <Row className="mb-5  w-75 flex-column justify-content-center  md-col-4 align-items-center">
                <Col>
                    <p className="f font-weight-bold">
                        Thanks for Successfully Completing your transaction, what did we do well and how can we do better?
                    </p>
                    <p>
                        Please type your response below . Please do not enter any personal information (e.g name, phone, telephone,
                        numbers, account or card details when providing your feedback
                    </p>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group
                            controlId="formBasicEmail"
                            className="m-0 small"
                        >
                            <Form.Control
                                type="text"
                                placeholder="Feedback"
                                as="textarea"
                                rows={4}
                                value={val}
                                onChange={(e) => {
                                    setVal(e.target.value);
                                }}
                            />
                        </Form.Group>
                        <Col className="my-5 mx-0 p-0 w-100">
                            <AppButton
                                value={loading ? ".....loading" : "Submit"}
                                type="submit"
                                showLoader
                                isLoading={loading}
                                disabled={loading}
                            />
                        </Col>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};
export default Feedback;
